export default "__VITE_ASSET__BzIhsSlO__"